import { parse } from 'query-string';
import { useConnect } from '@hooks/@lore/query-connect';
import useNetwork from '@/hooks/useNetwork';

export default function useQuery(props) {
  const {
    location = {},
    PAGE_SIZE = 0, // 0 = count only: server returns metadata but no record data
    returnCsvQuery = false } = props;

  const network = useNetwork();

  const query = {
    where: {
      // the distance here is in miles because it is not using a lat/lng calculation
      // do not include networkId because we want to find any nearby users wrt network
      filter: { intent: 'educator', siteNetwork: network?.id, nearby: 50, unaffiliated: true }
    },
    pagination: returnCsvQuery ? undefined : {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query;
  }

  return result;
}
